import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import {
  InstallDetection,
  MARKET_PENETRATION_OVER_TIME,
  QueryPayload,
  QueryVariables,
} from "../../../apis/companySearch/marketPenetrationOverTime";
import { COMPANY_SEARCH_CLIENT } from "../../../utils/consts";

export function useGetMarketPenetrationOverTime(variables: QueryVariables) {
  const { data, loading } = useQuery<QueryPayload, QueryVariables>(
    MARKET_PENETRATION_OVER_TIME,
    {
      variables,
      context: { clientName: COMPANY_SEARCH_CLIENT },
    }
  );

  const memoizedData = useMemo<InstallDetection[]>(
    () => data?.marketPenetrationOverTime || [],
    [data?.marketPenetrationOverTime]
  );

  return {
    loading,
    data: memoizedData,
  };
}
